import { MarkSpec, NodeSpec, Schema } from 'prosemirror-model';
import { Observable } from 'rxjs';

import { RtSchemaType } from '../editor/types';
import { DocNode, HardBreakNode, ParagraphNode, TextNode } from '../plugins/basic/nodes';
import { BulletListNode, ListItemNode, OrderedListNode } from '../plugins/list/nodes';
import { StrongMark } from '../plugins/marks/bold/bold-mark';
import { EmMark } from '../plugins/marks/italic/italic-mark';
import { LinkMark } from '../plugins/marks/link/link-mark';
import { StrikethroughMark } from '../plugins/marks/strikethrough/strikethrough-mark';
import { UnderlineMark } from '../plugins/marks/underline/underline-mark';
import { LegacyMentionNode, MentionNode } from '../plugins/mentions/nodes';
import { MentionElement } from '../plugins/mentions/types';

export interface DefaultSchemaOptions {
  mentionDataSource$?: Observable<MentionElement[]>;
}

export enum RtSchema {
  Default,
}

// prettier-ignore
type DefaultSchema = RtSchemaType<
  typeof DocNode | typeof TextNode | typeof ParagraphNode | typeof HardBreakNode | typeof OrderedListNode | typeof BulletListNode | typeof ListItemNode | typeof MentionNode | typeof LegacyMentionNode,
  typeof StrongMark | typeof EmMark | typeof StrikethroughMark | typeof UnderlineMark | typeof LinkMark
>;

export const defaultSchemaFactory = (options?: DefaultSchemaOptions): DefaultSchema =>
  buildSchema({
    nodes: [
      new DocNode(),
      new TextNode(),
      new ParagraphNode(),
      new HardBreakNode(),
      new OrderedListNode(),
      new BulletListNode(),
      new ListItemNode(),
      new MentionNode(options?.mentionDataSource$),
      new LegacyMentionNode(),
    ],
    marks: [
      new StrongMark(),
      new EmMark(),
      new StrikethroughMark(),
      new UnderlineMark(),
      new LinkMark(),
    ],
  });

const buildSchema = ({ nodes, marks }: { nodes: NodeSpec[]; marks: MarkSpec[] }) => {
  const nodesSpec = Object.fromEntries(nodes.map(node => [(<any>node).constructor.nodeName, node]));
  const marksSpec = Object.fromEntries(marks.map(mark => [(<any>mark).constructor.markName, mark]));

  return new Schema({ nodes: nodesSpec, marks: marksSpec });
};
